import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  page: string;
  confirmText?: string;
  cancelText?: string;
  fullScreen?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  page,
  confirmText = "Yes",
  cancelText = "No",
  fullScreen = false,
}) => {
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="dialog-title"
      className="Dialogbox-display"
    >
      <DialogTitle id="dialog-title" className="responsive-dialog-title-txt">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="md-alert-clr">
          Do you want to delete the selected {page} rows?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="modal-btn-b" autoFocus onClick={onClose}>
          {cancelText}
        </Button>
        <Button className="modal-btn-b" onClick={onConfirm} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
